module.exports = __webpack_public_path__ + "static/media/jeriod_logo.050a6440.png";